// Retention offer data model for the SaaS billing prototype.
// See plans/saas-billing/01-stripe-billing-foundation.md for canonical types.
//
// Canonicalized here so #05 doesn't redefine. Max 2 offers shown to a user
// attempting to cancel (#05 enforces).

export type RetentionOfferType = 'discount' | 'downgrade' | 'pause' | 'help_link';

export interface RetentionOffer {
  retentionOfferId?: string;
  type: RetentionOfferType;
  headline: string;                    // "20% off the next 3 months"
  body: string;                        // "Stay on Professional at $128/mo instead of $160."
  ctaLabel: string;                    // "Apply discount and stay"
  // For 'discount': payload binds a Stripe Coupon id that PromoCode admin pre-created.
  // For 'downgrade': payload binds a target { tier, seats, period } that delegates to #04.
  // For 'pause' / 'help_link': payload is implementation-defined.
  payload: Record<string, unknown>;
}
